export default __webpack_public_path__ + "static/bg-shop-interior-5db8533477c6fd9e7f329e63fe7c4e13.jpeg";